module.exports = __webpack_public_path__ + "img/image_gallery10.3c716309.jpg";